module.exports = __webpack_public_path__ + "static/media/logo.829e8a33.svg";